import React from 'react'
import { Typography, Button } from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

const No = (props) => {
	const history = useHistory()
	const dispatch = useDispatch()
	const params = useParams()
	const facility = useSelector((state) => state.specific.facilities.selected)
	return (
		<div
			style={{
				display: 'flex',
				width: '100%',
				height: '100vh',
				justifyContent: 'center',
				alignItems: 'center'
			}}>
			<div
				style={{
					textAlign: 'center'
				}}>
				<Typography variant="h2" style={{ color: '#3B0275', fontSize: '22px', marginBottom: '40px' }}>
					You have insufficient permissions to view this app.
				</Typography>
			</div>
		</div>
	)
}

export default No
